import axios from 'axios';
import bearerTokenHeader from 'components/api-authorization/bearerToken';

export interface IEppDamperType {
  eppDamperTypeID: number;
  name: string;
}

export const getEppDamperTypes = async () => {
  const config = await bearerTokenHeader();
  const response = await axios.get('api/EppDamperType', config);
  return response.data;
};
